export default __webpack_public_path__ + "static/media/36.e28eea04.png";